var DEFAULT_VALUE = {
    loaded: false,
    path: '',
    routeName: '',
    name: '',
};
export var findItemByName = function (_a) {
    var items = _a.items, nameToFind = _a.nameToFind;
    return items.find(function (item) { return item.name === nameToFind; }) || DEFAULT_VALUE;
};
